/**
 * planned-points.js — de geplande boringen (monsterplan) van een project, gedeeld door de
 * boringdetails op een pagina: één ophaalactie per project, zoals utils/sublocations.js.
 *
 * Zonder GeoDesk weigert de backend de geplande punten (403); dat is hier gewoon een lege lijst.
 * Velden die op geplande punten steunen, staan er dan niet: dezelfde regel als in de veldapp.
 */

import { api } from '../api.js';

/** Venster-event na elke wijziging. detail: { projectId, points } */
export const PLANNED_POINTS_EVENT = 'mv-planned-points-changed';

const cache = new Map();

/**
 * Punten met hun status zoals de backend die bepaalt: `status` 'done'/'open' en `boringId` van
 * de boring die het punt uitvoert (expliciet gekoppeld of op naam).
 */
export function loadPlannedPoints(projectId, { refresh = false } = {}) {
  if (!projectId) return Promise.resolve([]);
  if (refresh || !cache.has(projectId)) {
    const p = api.getPlannedPoints(projectId)
      .then((res) => res?.points || [])
      .catch(() => []);
    cache.set(projectId, p);
    if (refresh) p.then((points) => window.dispatchEvent(new CustomEvent(PLANNED_POINTS_EVENT, { detail: { projectId, points } })));
  }
  return cache.get(projectId);
}
